<template>
  <div
    :style="{ 'mask-image': `url('${src}')` }"
    style="mask-size: 100% 100%"
  ></div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'HomeBottomNavs',
  components: {},
  props: {
    src: { type: String, default: '' },
  },
  data() {
    return {
      hsbColor: {},
      rgbColor: {},
    }
  },
  mounted() {},
  methods: {},
})
</script>
